let timeOut;
export const debounceCallback = (callback, delay = 500) => {
  clearTimeout(timeOut);
  timeOut = setTimeout(() => callback(), delay);
};
